export default __webpack_public_path__ + "static/media/logo-leanlancer.32c938f5.png";